import * as React from 'react';

export default class Radio extends React.Component {
  render() {
    let { name, classes, value, checked, onChange, defaultChecked } =
      this.props;
    return (
      <div className={'radio ' + (classes ? classes : '')}>
        <input
          type='radio'
          defaultChecked={defaultChecked}
          name={name}
          value={value}
          checked={checked}
          onChange={() => onChange()}
        />
        <span />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/theme/Radio.js